import React, {useRef} from "react";
import {
    ReactComponent as ArrayDownIcon
} from '../../../../../../../../assets/main/groups/main-table/arrow-down-two.svg';
import {ReactComponent as ArrayUpIcon} from '../../../../../../../../assets/main/groups/main-table/arrow-up.svg';


interface ProfileNameProps {
    firstName: string | null;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ProfileName: React.FC<ProfileNameProps> = ({firstName, open, setOpen}) => {
    const profileNameRef = useRef<HTMLDivElement | null>(null);

    const onClickSelectHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        setOpen((prevOpen) => !prevOpen);
    };

    return (
        <div className="profile-name" onClick={onClickSelectHandler} ref={profileNameRef}>
            <span>
                {firstName}
            </span>
            <span>
                {open ? <ArrayUpIcon/> : <ArrayDownIcon/>}
            </span>
        </div>
    );
};
